import { colors } from '@opallabs/spectrum'

export const styles = {
  margin: 'auto',
  '.kuiper-alert-action .kuiper-button': {
    width: 'auto',
    '&.kuiper-secondary .kuiper-label': {
      color: colors.n5.base,
    },
  },
}
